export type OrderStatus = 'pending' | 'processing' | 'shipped' | 'delivered' | 'cancelled';

export interface OrderItem {
  name: string;
  qty: number;
  price: number;
  image: string;
}

export interface MockOrder {
  id: string;
  status: OrderStatus;
  createdAt: string;
  customer: { name: string; phone: string; city: string; address: string };
  items: OrderItem[];
  subtotal: number;
  shipping: number;
  total: number;
  payMethod: string;
  timeline: { status: OrderStatus; label: string; desc: string; date: string; done: boolean }[];
}

export const mockOrders: Record<string, MockOrder> = {
  '56805': {
    id: '56805',
    status: 'processing',
    createdAt: '2026-03-28',
    customer: { name: 'أحمد محمد', phone: '+971 50 123 4567', city: 'دبي', address: 'شارع الشيخ زايد، برج خليفة، الطابق 10' },
    items: [
      { name: 'عطر الملكة الذهبي 50ml', qty: 1, price: 349, image: 'https://public.readdy.ai/ai/img_res/7cdb3374c506da7a2ffeedfe4e75c469.jpg' },
      { name: 'عطر الليل العربي 100ml', qty: 2, price: 420, image: 'https://readdy.ai/api/search-image?query=dark%20luxury%20arabic%20perfume%20oud%20bottle%20black%20gold%20packaging%20white%20background%20studio&width=80&height=80&seq=o2&orientation=squarish' },
    ],
    subtotal: 1189,
    shipping: 0,
    total: 1189,
    payMethod: 'Tabby — تقسيط 4 دفعات',
    timeline: [
      { status: 'pending', label: 'تم تسجيل الطلب', desc: 'استلمنا طلبك بنجاح', date: '28 مارس 2026، 10:32 ص', done: true },
      { status: 'processing', label: 'قيد التجهيز', desc: 'فريقنا يجهّز طلبك الآن', date: '28 مارس 2026، 02:15 م', done: true },
      { status: 'shipped', label: 'في الطريق إليك', desc: 'سيصل خلال 1-2 يوم عمل', date: 'متوقع 30 مارس 2026', done: false },
      { status: 'delivered', label: 'تم التوصيل', desc: 'استلمت طلبك بنجاح', date: '—', done: false },
    ],
  },
  '72341': {
    id: '72341',
    status: 'shipped',
    createdAt: '2026-03-27',
    customer: { name: 'سارة العلي', phone: '+971 55 987 6543', city: 'أبوظبي', address: 'كورنيش أبوظبي، برج النيلوفر، الطابق 5' },
    items: [
      { name: 'كريم الوجه بالذهب 24K', qty: 1, price: 520, image: 'https://readdy.ai/api/search-image?query=gold%2024k%20luxury%20face%20cream%20skincare%20elegant%20packaging%20white%20background%20studio%20photography&width=80&height=80&seq=o3&orientation=squarish' },
      { name: 'سيروم النضارة الملكي', qty: 1, price: 280, image: 'https://readdy.ai/api/search-image?query=luxury%20royal%20serum%20skincare%20bottle%20dropper%20gold%20packaging%20white%20clean%20background&width=80&height=80&seq=o4&orientation=squarish' },
    ],
    subtotal: 800,
    shipping: 25,
    total: 825,
    payMethod: 'Apple Pay',
    timeline: [
      { status: 'pending', label: 'تم تسجيل الطلب', desc: 'استلمنا طلبك بنجاح', date: '27 مارس 2026، 09:10 ص', done: true },
      { status: 'processing', label: 'قيد التجهيز', desc: 'تم تجهيز الطلب وتغليفه', date: '27 مارس 2026، 01:45 م', done: true },
      { status: 'shipped', label: 'في الطريق إليك', desc: 'طلبك مع المندوب الآن', date: '29 مارس 2026، 08:00 ص', done: true },
      { status: 'delivered', label: 'تم التوصيل', desc: 'استلمت طلبك بنجاح', date: 'متوقع اليوم', done: false },
    ],
  },
  '89012': {
    id: '89012',
    status: 'delivered',
    createdAt: '2026-03-20',
    customer: { name: 'خالد الراشد', phone: '+971 52 456 7890', city: 'الشارقة', address: 'منطقة المجاز، شارع الاتحاد' },
    items: [
      { name: 'مجموعة العناية الفاخرة', qty: 1, price: 890, image: 'https://readdy.ai/api/search-image?query=luxury%20skincare%20gift%20set%20collection%20gold%20bottles%20elegant%20packaging%20white%20studio%20background&width=80&height=80&seq=o5&orientation=squarish' },
    ],
    subtotal: 890,
    shipping: 0,
    total: 890,
    payMethod: 'بطاقة ائتمان — VISA',
    timeline: [
      { status: 'pending', label: 'تم تسجيل الطلب', desc: 'استلمنا طلبك بنجاح', date: '20 مارس 2026، 11:00 ص', done: true },
      { status: 'processing', label: 'قيد التجهيز', desc: 'تم تجهيز الطلب وتغليفه', date: '20 مارس 2026، 03:30 م', done: true },
      { status: 'shipped', label: 'في الطريق إليك', desc: 'تم التسليم لشركة الشحن', date: '22 مارس 2026، 10:00 ص', done: true },
      { status: 'delivered', label: 'تم التوصيل', desc: 'تم استلام الطلب بنجاح ✓', date: '24 مارس 2026، 02:15 م', done: true },
    ],
  },
};
